var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 175.32 234.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#666666;stroke-miterlimit:10;}.cls-2{fill:#666666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.91 229.3 5.41 229.3 12.11 44.8 163.21 44.8 169.91 229.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.91,234.6H5.41a5.52,5.52,0,0,1-3.9-1.6A5.34,5.34,0,0,1,0,229.1L6.71,44.6a5.4,5.4,0,0,1,5.4-5.2h151.1a5.4,5.4,0,0,1,5.4,5.2l6.7,184.5a5.05,5.05,0,0,1-1.5,3.9A5.52,5.52,0,0,1,169.91,234.6ZM11,223.9h153.3L158,50.2H17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.41,74a5.38,5.38,0,0,1-5.4-5.4V50.2a39.4,39.4,0,0,0-78.8,0V68.6a5.4,5.4,0,1,1-10.8,0V50.2a50.2,50.2,0,0,1,100.4,0V68.6A5.38,5.38,0,0,1,132.41,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.81,201.6H6.61a5.4,5.4,0,0,1,0-10.8h162.2a5.4,5.4,0,1,1,0,10.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.caf71eaec56d20f46dd820ac2fa2c260.svg";
export { ForwardRef as ReactComponent };